import React, { useEffect } from "react";
import {
  Container,
  Box,
  Grid,
  Divider,
  Typography,
  Card,
  CardMedia,
  CardContent,
  CardActionArea,
  CardActions,
  Link,
  Button,
  Skeleton,
} from "@mui/material";
import { Scale } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import Project from "../Home/PageNotFound";
import { useParams } from "react-router-dom";
import { getDeveloper } from "../../features/Developers/developerSlice";

const Projects = () => {
  const { dev } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getDeveloper(`${dev}`));
  }, []);

  const { developer, developers, pending } = useSelector(
    (state) => state.developers
  );
  const { attributes, projects } = developer;
  return (
    <>
      <Container maxWidth="md">
        <Box sx={{ pb: 5 }}>
          <Box sx={{ pb: 3 }}>
            <Typography variant="h3">Projects</Typography>
            <Typography variant="h5"> Check Out some of ma projects</Typography>
          </Box>
          <Box>
            <Grid container spacing={2}>
              {projects?.length > 0 ? (
                projects?.map((project) => {
                  const { attributes, id } = project;
                  return (
                    <Grid item xs={12} sm={6} md={4} lg={4}>
                      <Card sx={{ maxWidth: 345 }}>
                        {!pending ? (
                          <CardMedia
                            component="img"
                            height="140"
                            image={`${attributes?.project_cover}`}
                            alt="green iguana"
                          />
                        ) : (
                          <Skeleton
                            animation="wave"
                            variant="rectangular"
                            width={345}
                            height={125}
                          />
                        )}
                        <CardContent>
                          {!pending ? (
                            <Typography
                              gutterBottom
                              variant="h5"
                              component="div"
                            >
                              {attributes?.project}
                            </Typography>
                          ) : (
                            <Skeleton
                              animation="wave"
                              variant="text"
                              width="100%"
                              height={50}
                            />
                          )}
                          {!pending ? (
                            <Typography variant="body2" color="text.secondary">
                              {attributes?.description}
                            </Typography>
                          ) : (
                            <Skeleton
                              animation="wave"
                              variant="text"
                              width="100%"
                              height={50}
                            />
                          )}
                        </CardContent>
                        <CardActions>
                          {!pending ? (
                            <Button
                              href={`${attributes?.github_link}`}
                              size="small"
                              variant="outlined"
                            >
                              GITHUB LINK
                            </Button>
                          ) : (
                            <Skeleton
                              animation="wave"
                              variant="rectangular"
                              width="100%"
                              height={20}
                              p={3}
                              // m={2}
                            />
                          )}
                          {!pending ? (
                            <Button
                              href={`${attributes?.live_link}`}
                              size="small"
                              variant="outlined"
                            >
                              LIVE LINK
                            </Button>
                          ) : (
                            <Skeleton
                              animation="wave"
                              variant="rectangular"
                              width="100%"
                              height={20}
                              p={3}
                              // m={2}
                            />
                          )}
                        </CardActions>
                      </Card>
                    </Grid>
                  );
                })
              ) : (
                <Skeleton
                  variant="rectangular"
                  width="100%"
                  height={300}
                  animation="wave"
                />
              )}
            </Grid>
          </Box>
        </Box>
      </Container>
    </>
  );
};

export default Projects;
